import React from 'react';
import './style.scss';

function ModuleHeader(props) {
    return (
        <div className="module-header">
            {props.children}
        </div>
    )
}

export default ModuleHeader
